// Drafts.js
import React, { useEffect, useState } from 'react';
import {
    Container,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Icon,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit'; 
import { DeleteOutlined } from '@mui/icons-material';
import axios from 'axios';

const Drafts = ({ setDraftToEdit }) => { // Accept setter function as prop
    const [drafts, setDrafts] = useState([]);

    useEffect(() => {
        fetchDrafts(); // Fetch drafts on component mount
    }, []);

    const fetchDrafts = async () => {
        try {
            const response = await axios.get('https://form.cpccbe.org/api/emails/drafts');
            setDrafts(response.data); // Set drafts data
        } catch (error) {
            console.error("Error fetching drafts:", error);
        }
    };

    const handleEditDraft = (draft) => {
       
        setDraftToEdit(draft); // Set draft to edit in parent component
    };

    const handleDeleteDraft = async (draft) => {
        try {
            if (!window.confirm("Are you sure you want to delete this draft?")) {
                return;
            }
    
           const response =  await axios.delete(`https://form.cpccbe.org/api/emails/delete-draft/${draft._id}`);
            fetchDrafts(); // Fetch drafts after deletion
            alert(response.data.message || "Draft Deleted Successfully")
        } catch (error) {
            console.error("Error deleting draft:", error);
        }
    }

    return (
        <Container>
            <Typography variant="h4" gutterBottom>
                Drafts
            </Typography>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Recipient</TableCell>
                            <TableCell>Subject</TableCell>
                            <TableCell>Body</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Actions</TableCell> {/* New column for actions */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {drafts.map((draft) => (
                            <TableRow key={draft._id}>
                                <TableCell>{draft.recipient}</TableCell>
                                <TableCell>{draft.subject}</TableCell>
                                <TableCell>{draft.body}</TableCell>
                                <TableCell>{new Date(draft.createdAt).toLocaleString()}</TableCell>
                                <TableCell>
                                    <IconButton onClick={() => handleEditDraft(draft)}>
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton  onClick={() => handleDeleteDraft(draft)}>
                                        <DeleteOutlined />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Container>
    );
};

export default Drafts;
